import { useAuth } from '@hooks';
import { OptionalRoutesEnum } from 'routes/enums';
import { HomeRouter } from '@flows/private/home/router';

import { ResponsibilityLetterLayout } from './layout';

export function ResponsibilityLetterPage() {
  const { optionalRoutes } = useAuth();

  const responsibilityLetterExists =
    optionalRoutes?.[OptionalRoutesEnum.RESPONSIBILITY_LETTER];

  if (!responsibilityLetterExists) {
    window.location.replace(HomeRouter.path);
    return null;
  }

  return <ResponsibilityLetterLayout />;
}
